export const translations = {
    stepLabel: {
        START: 'Početak',
        DETAILS: 'Detalji',
        SUBMITTER: 'Podnosilac/Osiguranik',
        USER: 'Korisnik',
        PAYMENT: 'Isplata',
        DOCUMENTATION: 'Dokumentacija',
        CONFIRMATION: 'Potvrda',
    },
    insuredPerson: {
        INSURED_PERSON: 'Podnosilac / Osiguranik',
        INSURED_PERSON_HOLDER: 'Prijavu podnosi:',
        LAWYER: 'Fizičko lice/punomoćnik (advokat)',
    },
    attorney: {
        NAME: 'Ime i prezime / Naziv punomoćnika',
        ADDRESS: 'Ulica i broj punomoćnika',
        CITY: 'Mesto punomoćnika',
        ZIP_CODE: 'Poštanski broj punomoćnika',
        COUNTRY: 'Država punomoćnika',
    },
    users: {
        ADD_NEW: ' + Dodaj korisnika',
        CANCEL: 'Odustani',
        SAVE: 'Sačuvaj',
        USERS_LIST: 'Lista korisnika',
        ADD_USER_DATA_OUTLIVE: 'Potrebno je dopuniti podatke',
    },
    policyUser: {
        USER: 'Korisnik',
        USERS: 'Korisnici',
        ADD_USER_DATA: 'Unesite podatke za sve korisnike navedene na polisi',
        ADD_USER_DATA_PURCHASE_1: 'Korisnik za isplatu otkupne vrednosti po izabranoj polisi može biti ',
        ADD_USER_DATA_PURCHASE_2: 'samo ugovarač osiguranja.',
        ADD_USER_DATA_PURCHASE_3:
            ' Molimo Vas da proverite popunjene podatke za korisnika, ispravite ih ukoliko su promenjeni i dopunite prazna polja.',
        ADD_USER_DATA_PURCHASE_4:
            'Podaci o ličnom dokumentu se popunjavaju za vlasnika pravnog lica ili njegovog zakonskog zastupnika.',
        ADD_USER_DATA_OUTLIVE:
            'Korisnici za slučaj doživljenja isteka osiguranja su navedeni u tabeli. Molimo vas da proverite popunjene podatke za svakog korisnika, ispravite ih ukoliko su promenjeni i dopunite prazna polja.',
        USER_BY_POLICY: 'Da li ste korisnik po polisi? *',
        SUBMITTER_USERS_ATTORNEY: 'Da li ste ovlašćeni punomoćnik korisnika osiguranja? *',
        ARE_YOU_LISTED_AS_USER_1: 'Da li ste Vi na polisi broj',
        ARE_YOU_LISTED_AS_USER_2: 'navedeni kao korisnik osiguranja? *',
        THE_ONLY_USER: 'Da li ste jedini korisnik po gore navedenoj polisi? *',
        SUBMITTER_PERSON: 'Podnosilac',
        SUBMITTER_AND_ADDITIONAL_PERSONS: 'Podnosilac i dodatna lica',
        THIRD_PERSON: 'Treće lice (roditelj/zakonski staratelj, zakonski naslednik)',
        PAYMENT_DATA: 'Podaci za isplatu:',
        ACCOUNT: 'Tekući račun',
        JMBG: 'JMBG (isplaćenu naknadu mozete podići u najbližoj Pošti uz ličnu kartu)',
        PAYMENT_REMARK: 'Napomena: Isplata naknade iz osiguranja se realizuje u valuti u kojoj je ugovorena polisa.',
        DOMESTIC: 'Domaća banka - dinarski račun',
        DOMESTIC_LEGAL_ENTITY: 'Domaća banka - dinarski račun pravnog lica',
        DOMESTIC_IBAN: 'Domaća banka - devizni račun (IBAN)',
        DOMESTIC_IBAN_LEGAL_ENTITY: 'Domaća banka - devizni račun (IBAN) pravnog lica',
        INTERNACIONAL: 'Inostrana banka',
        ACCOUNT_NUM: 'Broj računa',
        AGREEMENTS: 'Saglasnosti:',
        DELIVERY_AGREEMENT:
            'Da li ste saglasni da Generali Osiguranje Srbija Odluku o zahtevu dostavi i ugovaraču osiguranja (privrednom društvu, udruženju, školi, drugoj ustanovi) ) i posredniku/zastupniku u osiguranju posredstvom kojih je ugovor o osiguranju zaključen? *',
        DEMAND_AGREEMENT:
            'Da li ste saglasni da Generali Osiguranje Srbija Ugovaraču dostavi zahteve i informacije o nedostajućoj dokumentaciji (uključujući i medicinsku dokumentaciju) koja je potrebna radi okončanja postupka likvidacije Vašeg zahteva i da tu naknadno pribavljenu dokumentaciju Ugovarač dostavlja Generali Osiguranju Srbija? *',
        SMS_AGREEMENT:
            'Saglasan sam da putem sms-a na broj telefona naveden u zahtevu dobijem informaciju o plaćanju. *',
        EMAIL_AGREEMENT:
            'Saglasan sam da elektronskim putem na e-mail adresu navedenu u zahtevu dobijam Pisma obaveštenja i Odluku o zahtevu. *',
        BANK_SELECTION: 'Izbor banke',
        BANK_NAME: 'Naziv banke',
        SAME_PAYMENT_TYPE:
            'Neophodno je za sve korisnike odabrati isti način isplate. Za korisnike koji su strani državljani moguća je samo isplata na račun.',
        SUBMITTER_STATEMENT:
            'Izjavljujem pod punom odgovornošću da zahtev podnosim u svoje ime i za svoj račun i da ne postoji drugo lice koje me posredno ili neposredno kontroliše, ili za čiji račun istupam.',
        SUBMITTER_STATEMENT_NOTE: 'Molimo Vas da navedete podatke o licu za čiji račun istupate:',
    },
    claimDetailsLife: {
        DETAILS: 'Detalji',
        DESCRIPTION: 'Detaljan opis nastanka osiguranog slučaja (mesto, uzrok, pri kojoj delatnosti)*',
        TYPE_OF_INJURY: 'Vrsta povrede (šta je povređeno?)*',
        SURGICAL_INTERVENTION: 'Hirurška intervencija (koja je izvršena) i datum kada je izvršena*',
        HOSPITAL_DAYS: 'Bolnički dani',
        HOSPITAL_DAYS_NOTE: '(ukoliko ste boravili u bolnici duže od jednog dana)',
        HOSPITAL_DAYS_FROM: 'Od *',
        HOSPITAL_DAYS_TO: 'Do *',
        INVESTIGATION: 'Da li se usled nesrećnog slučaja vodi istraga i ko je vodi?*',
        FIRST_AID: 'U kojoj zdravstvenoj ustanovi je pružena prva pomoć?*',
        PHYSICAL_FLAW: 'Da li ste pre ovog nesrećnog slučaja imali neku telesnu manu? Koju?*',
        SAME_INJURY: 'Da li ste ranije imali istu povredu kao u ovom nesrećnom slučaju i sa kakvim posledicama?*',
        PROHIBITED_SUBSTANCES:
            'Da li ste u trenutku nezgode bili pod dejstvom alkohola ili droga i da li ste se od istih lečili?*',
        CAUSE: 'Uzrok boravka u bolnici (dijagnoza) *',
        HOSPITAL_TYPE: 'U kojoj zdravstvenoj ustanovi ste boravili?*',
        FIRST_CONTACT_DATE:
            'Datum kada ste se prvi put obratiili lekaru ili zdravstvenoj ustanovi sa simptomima bolesti, zbog koje ste boravili u bolnici.*',
        MEDICAL_RECORD:
            'Navesti broj Vašeg zdravstvenog kartona, kao i naziv i adresu  Doma zdravlja u kom se lečite.*',
        DR_NAME: 'Ime lekara koji je konstatovao smrtni slučaj i naziv ustanove *',
        INSITUTION_NAME: 'Naziv zdravstvene ustanove gde je osiguranik bio lečen (imao zdravstveni karton) *',
        DIAGNOSIS: 'Dijagnoza zbog koje je izvršena hirurška intervencija*',
        NAME_SURGICAL_INTERVENTION: 'Naziv izvršene hirurške intervencije*',
        HOSPITAL_OF_SURGICAL: 'U kojoj zdravstvenoj ustanovi je izvršena hirurška intervencija?*',
        DATE_OF_FIRST_CONTACT:
            'Datum kada ste se prvi put obratiili lekaru ili zdravstvenoj ustanovi sa simptomima bolesti, zbog koje je izvršena hirurška intervencija.*',
        DEATH_CAUSE: 'Uzrok nastanka*',
        CASE_DESCRIPTIOM:
            'Detaljan opis nastanka nesrećnog slučaja, mesto nastanka nesrecnog slucaja i pri kojoj delatnosti je doslo do nesrecnog slucaja?*',
        PROHIBITED_SUBSTANCES_DEATH: 'Da li je osiguranik u trenutku nezgode bio pod dejstvom alkohola ili droga? *',
        DATE_SERIOUS_ILLNESS:
            'Datum kada ste se prvi put obratili lekaru sa simptomima bolesti, kada je i od strane koga utvrđena prijavljena dijagnoza? *',
        DIAGNOSIS_SERIOUS_ILLNESS: 'Dijagnoza teže bolesti sa zdravstvene dokumentacije koju prilažete:*',
        SERIOUS_ILLNESS_TREATMENT:
            'Da li ste se bolnički ili ambulantno lečili ili se lečite, a u vezi sa prijavljenom težom bolesti ? U kojoj ustanovi?:*',
        OUTLIVE_DEBT_AMOUNT_LABEL: 'Stanje duga po izabranoj polisi ',
        CAPITALIZED_LABEL: 'Polisa je kapitalizovana ',
        OUTLIVE_TEXT_LABEL_1: 'Isplata doživljenja po polisi je moguća samo nakon izmirenja svih dospelih obaveza. ',
        OUTLIVE_TEXT_LABEL_2:
            'U skladu sa Zakonom o porezu na dohodak građana postoji obaveza obračunavanja i uplate poreza na prihode od osiguranja lica po poreskoj stopi od 15%. Osiguravač, Generali osiguranje, je u obavezi da prilikom isplate obračuna i isplati porez u ime i za račun osiguranika- korisnika osiguranja. Oporezivi prihod predstavlja vrednost isplaćene naknade iz osiguranja lica (osigurana suma + dobit) umanjene za iznos novčanih sredstava uplaćenih po osnovu premije (iznos koji je klijent uplatio)',
        OUTLIVE_POLICY_NUMBER: 'Za polisu ',
        OUTLIVE_CLAIM_NUMBER: ' je otvoren zahtev za naknadu ',
        OUTLIVE_TABLE_HEAD_COLUMN_1: 'Opis',
        OUTLIVE_TABLE_HEAD_COLUMN_2: 'Iznos',
        PAYMENT_AMOUNT: 'Ukupno za isplatu',
        OUTLIVE_TAX_LABEL_1:
            'Obaveštavamo Vas da ćemo u Vaše ime i za Vaš račun platiti porez na prihod od osiguranja lica. Oporezivi prihod  iznosi ',
        OUTLIVE_TAX_LABEL_2:
            ' (isplaćena suma osiguranja uvećana za dobit i umanjena za premiju koju ste uplatili za vreme trajanja ugovora o osiguranju)',
        OUTLIVE_TAX_LABEL_3:
            'U odnosu na ovaj iznos primenili smo poresku stopu od 15% i na ime poreza ćemo platiti:  ',
        PURCHASE_TABLE_HEAD_COLUMN_2: 'Validno',
        PURCHASE_TEXT_NOTE:
            'OVAJ OBRAČUN JE INFORMATIVNOG KARAKTERA I ZADRŽAVAMO MOGUĆNOST DA DOĐE DO IZMENA U TOKU OBRADE ZAHTEVA.',
        PURCHASE_TEXT_LABEL_1: 'Otkupna vrednost polise na dan ',
        PURCHASE_TEXT_LABEL_2: 'je obračunata na ',
        PURCHASE_TEXT_LABEL_3: ' godini i iznosi ',
        PURCHASE_TEXT_LABEL_4:
            'Obaveštavamo Vas da ćemo u Vaše ime i za Vaš račun platiti porez na prihod od osiguranja lica.',
        PURCHASE_TEXT_LABEL_5: 'Oporezivi prihod iznosi ',
        PURCHASE_TEXT_LABEL_6:
            ' (isplaćena suma osiguranja uvećana za dobit i umanjena za premiju koju ste uplatili za vreme trajanja ugovora o osiguranju).',
        PURCHASE_TEXT_LABEL_7:
            'U odnosu na ovaj iznos primenili smo poresku stopu od 15% i na ime poreza ćemo platiti: ',
        PURCHASE_PAYMENT_AMOUNT_NULL:
            'Otkupna vrednost za ovu polisu nije dostupna. Molimo Vas da potražite drugim putem (kalkulator, prepis polise)',
    },
    personalInfo: {
        SUBMITTER_ROLE:
            'U kom svojstvu podnosite zahtev za naknadu iz osiguranja (Punomoćnik, roditelj/staratelj, korisnik osiguranja, ugovarač osiguranja, član porodice…)?',
        SUBMITTER_ROLE_PURCHASE: 'U kom svojstvu podnosite zahtev za naknadu iz osiguranja?',
        NAME: 'Ime',
        LAST_NAME: 'Prezime',
        UCN: 'JMBG',
        ADDRESS: 'Adresa',
        CITY: 'Mesto',
        MOBILE: 'Mobilni telefon',
        MOBILE_STAR: 'Mobilni telefon *',
        AGREEMENT_1:
            'Da li ste saglasni da Generali Osiguranje Srbija dostavi Odluku o zahtevu ugovaraču osiguranja​ i/ili posredniku/zastupniku u osiguranju čijim posredstvom je zaključen ugovor o osiguranju?',
        AGREEMENT_2:
            'Da li ste saglasni da Generali Osiguranje Srbija ugovaraču osiguranja i/ili posredniku/zastupniku dostavi zahteve i informacije o dokumentaciji koja nedostaje, uključujući i medicinsku, a potrebna je za okončanje postupka likvidacije Vašeg zahteva, i da tu naknadno pribavljenu dokumentacija ugovarač/posrednik/zastupnik dostavi Generali Osiguranju Srbija? ',
        AGREEMENT_3: 'Saglasan sam da putem sms-a na broj telefona naveden u zahtevu dobijem informaciju o plaćanju.',
        AGREEMENT_4:
            'Saglasan sam da elektronskim putem na e-mail adresu navedenu u zahtevu dobijam Pisma obaveštenja i Odluku o zahtevu.',
        AGREEMENT_5:
            'Ovlašćujem lekare koji su lečili osiguranika, odnosno organe koji su vodili ili vode bilo kakvu istragu u vezi sa prijavljenim osiguranim slučajem, da mogu dati sve podatke koje bi tražio Generali Osiguranje Srbija a.d.o. Beograd.',
        AGREEMENT_6:
            'Dajem pristanak osiguravaču da obrađuje podatke o mom zdravstvenom stanju u svrhu ispunjenja ugovora o osiguranju;',
        AGREEMENT_7:
            'Oslobađam profesionalne obaveze čuvanja tajne lekare i paramedicinsko osoblje koje me je (moje dete/štićenika) pregledalo pre, u toku i posle nastanka osiguranog slučaja i dajem pristanak zdravstvenoj ustanovi koja mi je (mom detetu/štićeniku) pružila medicinsku uslugu, da saopšti osiguravaču sve neophodne informacije u vezi sa zdravstvenim stanjem i lečenjem osiguranika.',
        PAYMENT_REQUEST: 'Podnošenjem zahteva za naknadu:',
        EMAIL: 'E-mail',
        DUAL_CITIZENSHIP:
            'Ukoliko posedujete dvojno državljanstvo, molimo Vas da odaberete zemlju drugog državljanstva',
        PERMANENT_RESIDENCE: 'Prebivalište:',
        DEFAULT_SUBMITTER: 'Ugovarač',
        DESELECT: 'Obriši',
        PURCHASE_SUBMITTER_INFO_1: 'Zahtev za isplatu otkupne vrednosti po izabranoj polisi moze podneti ',
        PURCHASE_SUBMITTER_INFO_2: 'samo ugovarač osiguranja ili njegov punomoćnik.',
        PURCHASE_SUBMITTER_CONTRACTOR: 'Ugovarač osiguranja po izabranoj polisi',
        PURCHASE_SUBMITTER_ATTORNEY: 'Ovlašćeni punomoćnik',
    },
    legalInfo: {
        BUSINESS_NAME: 'Poslovno ime',
        VAT: 'PIB',
        EMAIL: 'E-mail',
        NAME: 'Ime zakonskog zastupnika firme',
        LAST_NAME: 'Prezime zakonskog zastupnika firme',
        MOBILE: 'Mobilni telefon/kontakt telefon firme *',
        CONTACT_EMAIL: 'E-mail',
        ADDRESS: 'Adresa',
        ESTABLISHMENT_DATE: 'Datum osnivanja *',
        ESTABLISHMENT_PLACE: 'Mesto osnivanja',
        PERMANENT_RESIDENCE: 'Sedište firme',
        GENDER: 'Pol zakonskog zastupnika firme',
        SELECT_PERSONAL_DOC_TYPE: 'Vrsta ličnog dokumenta zakonskog zastupnika firme',
        PERSONAL_DOC_NUMBER: 'Broj ličnog dokumenta zakonskog zastupnika firme',
        ISSUE_PLACE: 'Mesto izdavanja ličnog dokumenta zakonskog zastupnika firme',
        ISSUE_DATE: 'Datum izdavanja ličnog dokumenta zakonskog zastupnika firme *',
    },
    documentation: {
        ADD_DOC: 'Dodajte dokumenta u odgovarajuće kategorije',
        PERSONAL_ID: 'Lična karta (obe strane ili očitana)',
        BANK_ACC_CARD: 'Kartica tekućeg računa',
        PAYMENT_INSTRUCTION: 'Instrukcija za plaćanje',
        ATTORNEY_OR_AUTHORIZATION: 'Punomoć i/ili ovlašćenje',
        OWNERSHIP_PROOF: 'Dokaz o vlasništvu',
        MEDICAL_DOC: 'Medicinska dokumentacija',
        OTHER_DOC: 'Ostala dokumentacija',
        CHOOSE_DOC: 'odaberi dokument',
        EXEEEDS_ALLOWED_SIZE: 'Ne možete da dodate pojedinačni dokument veći od 20 MB.',
        TOTAL_UPLOAD_SIZE: 'Možete poslati najviše 25MB priloga.',
        FILE_ALREADY_UPLOADED: 'Ne možete ponovo dodati isti fajl.',
        FORMAT_NOT_ALLOWED: 'Format fajla koji ste dodali nije odgovarajući.',
        ALLOWED_FILE_FORMATS: 'Dozvoljeni formati su: pdf, jpg, png, doc(x), rtf, xls(x) i txt.',
        TOTAL_UPLOAD_SIZE_LABEL: 'Ukupna veličina priloga koju možete poslati je ',
        TOTAL_UPLOAD_SIZE_LEFT_LABEL: 'Preostala veličina priloga koju možete poslati je ',
        DOCUMENTATION_MB_SPACE: ' MB.',
        DOCUMENTATION_MB: 'MB',
        NOTICE: 'NAPOMENA: Ukoliko Vam nije utvrđen identitet na ličnom dokumentu* i/ili nije potpisan AML Upitnik za klijenta od strane zaposlenog u Generali Osiguranju Srbija, molimo Vas da odete do naše najbliže poslovnice kako bi kompletirali dokumentaciju. Zaposleni Generali Osiguranja Srbija će nam proslediti originale ova dva dokumenta, a radi bržeg rešavanja Vašeg zahteva, možete nam istovremeno poslati i sken/fotografiju  mejlom, na adresu naknadelife@generali.rs. Molimo Vas da se prilikom dostavljanja dodatne dokumentacije pozovete na oznaku i broj Vašeg zahteva, koje ćete dobiti po završetku prijave.\n*Ličnim dokumentom se smatra očitana lična karta ukoliko je čipovana, ili fotografija obe strane lične karte ukoliko ista nije čipovana, ili fotografija prve strane pasoša (sa ličnim podacima).',
        ADDITIONAL_DOC:
            'Osiguravač zadržava pravo da traži i drugu neophodnu dokumentaciju u cilju realizacije zahteva.',
        NOTICE_NECESSITY_VISITS_BRANCH:
            'NAPOMENA: Da biste kompletirali zahtev za naknadu potrebno je da Vam zaposleni u Generali Osiguranju Srbija utvrdi identitet na ličnom dokumentu i potpiše AML Upitnik za klijenta. Molimo Vas da, ukoliko već niste, nakon podnošenja online zahteva odete do najbliže poslovnice Generali Osiguranja Srbija kako biste obezbedili svu neophodnu dokumentaciju.',
    },
    confirmationScreen: {
        POLICY_NUMBER: 'Broj polise',
        REQUEST: 'Zahtev',
        AGREEMENT_HEADER: 'Podnošenjem zahteva za naknadu: ',
        AGREEMENT_1:
            'Izjavljujem da sam na sva pitanja istinito i potpuno odgovorio/la, kao i da ne postoje nikakve materijalne činjenice u vezi sa prijavljenim osiguranim slučajem koje su mi poznate a nisam ih prijavio/la; ',
        AGREEMENT_2:
            'Dajem saglasnost da Osiguravač ima pravo da osigurano lice pošalje na kontrolni pregled ili dodatni medicinski tretman, kojim bi se utvrdile neophodne činjenice u vezi sa prijavljenim osiguranim slučajem i da će eventualne troškove snositi osiguravač;',
        AGREEMENT_3:
            'Dajem pristanak osiguravaču da obrađuje podatke o mom zdravstvenom stanju u svrhu ispunjenja ugovora o osiguranju;',
        AGREEMENT_4:
            'Oslobađam profesionalne obaveze čuvanja tajne lekare i paramedicinsko osoblje koje me je (moje dete/štićenika) pregledalo pre, u toku i posle nastanka osiguranog slučaja i dajem pristanak zdravstvenoj ustanovi koja mi je (mom detetu/štićeniku) pružila medicinsku uslugu, da saopšti osiguravaču sve neophodne informacije u vezi sa zdravstvenim stanjem i lečenjem;',
        AGREEMENT_5:
            'Dajem saglasnost da GENERALI OSIGURANJE SRBIJA a.d.o. može dalje od mene zahtevati da dostavim svu dokumentaciju na osnovu koje se obavlja identifikacija klijenata, kao državljana ili rezidenata Sjedinjenih Američkih Država (fotokopije ličnih isprava i druge isprave, potvrde, saglasnosti), te da ću po zahtevu GENERALI OSIGURANJE SRBIJA a.d.o. istu dostaviti u najkraćem mogućem roku.',
        AGREEMENT_CONTACT:
            'Saglasan/-na sam da Generali Osiguranje Srbija a.d.o. sa mnom kontaktira, šalje mi korisne informacije, ponude i obaveštenja o proizvodima i uslugama osiguranja.',
        WRONG_PASS: 'Lozinka je neispravna ili je istekla. Proverite i pokušajte ponovo.',
        CLAIM_ERROR: 'Šteta nije snimljena. Pokušajte ponovo.',
        OPENED_REQUESTS: 'Po slanju podataka otvorićemo sledeće posebne zahteve:',
        VEHICLE_DAMAGE: 'Šteta na vozilu',
        OBJECT_DAMAGE: 'Šteta na objektu ili predmetu',
        INJURIES: 'Povrede i/ili nematerijalne posledice nezgode',
        AGREEMENT:
            'Saglasan/-na sam da Generali Osiguranje Srbija a.d.o. sa mnom kontaktira, šalje mi korisne informacije, ponude i obaveštenja o proizvodima i uslugama osiguranja.',
        PRIVACY: 'Više o načinu na koji upravljamo vašim podacima možete pročitati u našoj ',
        PRIVACY_NOTE:
            'Osiguravač nije u obavezi da pruži osiguravajuće pokriće niti da plati bilo kakav odštetni zahtev ili isplati bilo kakvu naknadu na osnovu ugovora o osiguranju u onoj meri u kojoj bi ga pružanje takvog pokrića, plaćanje takvog odštetnog zahteva ili omogućavanje takve naknade izložilo bilo kakvoj sankciji, zabrani ili ograničenju na osnovu rezolucija Ujedinjenih nacija ili trgovinskih ili ekonomskih sankcija, zakona ili propisa Evropske unije, Sjedinjenih Američkih država ili Republike Srbije.',
    },
    confirmationTable: {
        DATE_OF_ACCIDENT: 'Datum nastanka',
        RISK: 'Rizik',
        POLICY_OWNER: 'Ugovarač',
        POLICY_INSURED: 'Osiguranik',
        POLICY_USER: 'Korisnik',
        POLICY_USER_AND_PAYMENT: 'Korisnik - način isplate',
        POLICY_SUBMITTER: 'Zahtev podnosi',
        POLICY_SUBMITTER_CONTACT: 'Kontakt podaci podnosioca',
        POLICY_VALID_TO: 'Datum isteka polise',
        FULL_PAYMENT: 'Isplata u celosti',
        FULL_TRANSFER: 'Prenos',
        PARTIAL_TRANSFER: 'Delimični prenos',
        purchase: {
            AMOUNT: 'Iznos otkupne vrednosti za isplatu',
            PERIOD: 'Godina osiguranja na kojoj se realizuje otkup',
            DATE: 'Datum podnošenja zahteva za otkup',
            CONTRACTOR: 'Ugovarač',
            PAYMENT_TYPE: 'Način isplate',
        },
    },
    validationMessages: {
        REQUIRED_FIELD: 'Obavezno polje',
        POLICY_HOLDER_ID_OR_VAT_INVALID_FORMAT:
            'Molimo Vas da unesete PIB ili matični broj ugovarača u odgovarajućem formatu',
        POLICY_NUMBER_OFFER_NUMBER_OR_UCN_REQUIRED:
            'Molimo Vas da unesete broj polise ili broj ponude ili matični broj osiguranika.',
        PHONE_NUMBER_FORMAT: 'Potrebno je uneti broj telefona u odgovarajućem formatu (+xxxxxxxxxx)',
        PHONE_NUMBER_FORMAT_SERBIAN:
            'Morate da unesete broj telefona mobilnog operatera iz Srbije (u obliku +3816xxxxxx)',
        EMAIL_ADDRESS_FORMAT: 'Potrebno je uneti e-mail adresu u odgovarajućem formatu (xx@xx.xx)',
        LEGAL_ENTITY_NUMBER_INVALID_FORMAT: 'Matični broj nije u ispravnom formatu. Proverite podatke.',
        VAT_INVALID_FORMAT: 'Uneti PIB nije u ispravnom formatu. Proverite podatke.',
        UCN_INVALID_FORMAT: 'JMBG nije u odgovarajućem formatu!',
        ALREADY_HAS_UCN: 'Ne možete ponovo dodati isto lice.',
        NOT_ADULT: 'Lice je maloletno.',
        UNIQUE_CITIZEN_NUMBER_AND_BIRTH_NO_NOT_EQUAL: 'Datum rođenja se ne podudara sa JMBG',
        ADD_USER: 'Potrebno je dodati makar jednog korisnika.',
        COMPLETE_USER_DATA: 'Potrebno je dopuniti podatke o korisniku.',
        ACCOUNT_NUMBER_INVALID_FORMAT: 'Broj računa nije u ispravnom formatu. Proverite podatke.',
        ACCOUNT_NUMBER_INVALID_FORMAT_IBAN:
            'IBAN nije u ispravnom formatu. Mora da počinje sa RS35. Proverite podatke.',
        INSURED_CASE_ALREADY_EXIST:
            'Za unetog osiguranika već postoji podnet zahtev po odabranoj polisi za isti datum nastanka osiguranog slučaja.',
        DATA_AGREEMENT:
            'Bez prikupljanja i obrade podataka o ličnosti osiguravač nije u mogućnosti da ispuni obaveze iz ugovora o osiguranju.',
        OUTLIVE_AMOUNT_VALIDATION: 'Iznos ne može biti veći od ukupnog iznosa za isplatu.',
        OUTLIVE_AMOUNT_SUM_VALIDATION:
            'Zbir iznosa za prenos sredstava ne može biti veći od ukupnog iznosa za isplatu.',
        ALREADY_HAS_IMMATERIAL: 'Ne možete ponovo dodati isto lice.',
    },
    residentNormsTooltip: {
        NORM: '* Rezident Sjedinjenih Američkih Država je svaka ona osoba koja ispunjava sledeće kriterijume:',
        NORM_1: ' - ima dozvolu stalnog boravka (Green Card)',
        NORM_2: ' - provela je tekuće i prethodne dve godine više od ukupno 183 dana u Sjedinjenim Američkim Državama (način za izračunavanje broja dana: dani tekuće godine se računaju u celosti, minimum 31 dan, dani prošle kao jedna trećina, a dani godine koja prethodi prošloj godini računaju se kao šestina)',
        NORM_3: ' - prijavila je svoje prihode sa prihodima svojih američkih partnera.',
        EXCEPTION: 'Iz ovoga se izuzimaju:',
        EXCEPTION_1:
            ' - diplomate i zaposleni u međunarodnim organizacijama i članovi njihovih porodica, profesionalni sportisti (pod određenim uslovima), studenti, profesori',
        EXCEPTION_2: ' - osobe koje su se odrekle američkog državljanstva iil dozvole stalnog boravka (Green Card)',
        MORE_INFO:
            'Za više obaveštenja o kriterijumima za utvrđivanje rezidenta Sjedinjenih Američkih Država sa obavezom plaćanja poreza, molimo, pogledajte sajt IRS: ',
        LINK: 'https://www.irs.gov/',
        GEN_INFO:
            'U svakom slučaju, ukoliko se u toku procesa postupanja po ovom zahtevu utvrde indicije o SAD statusu klijenta, GENERALI OSIGURANJE SRBIJA a.d.o. može Vas naknadno kontaktirati i tražiti dodatno izjašnjavanje ili dodatnu dokumentaciju koja će biti sastavni deo ovog dokumenta.',
    },
    success: {
        SUCCESS_SINGLE_1: 'Uspešno ste podneli zahtev za naknadu.',
        SUCCESS_SINGLE_2: 'Potvrda o prijavi Vam je poslata na e-mail.',
        SUCCESS_MULTIPLE_1: 'Uspešno ste podneli zahteve za naknadu.',
        SUCCESS_MULTIPLE_2: 'Potvrde o prijavama poslali smo Vam posebno za svaki zahtev na e-mail.',
        CLAIM_NUMBER: '',
        NOTIFICATION_SEND: '',
        TYPE: 'Osigurani rizik',
        REQUEST_NUMBER: 'Broj zahteva',
    },
    userNotification: {
        CONFIRMATION_OF_APPLICANT: 'Potvrda podnosioca zahteva',
        RECIEVE_MESSAGE: 'Odaberite način za prijem jednokratne lozinke',
        SMS: 'SMS',
        EMAIL: 'Imejl',
        MSG_SENT: 'Poslali smo vam poruku/imejl',
        ONE_TIME_PASS: 'Jednokratna lozinka *',
        ERROR: 'Ne postoje podaci za unete kontakt podatke i privremenu lozinku!',
    },
    DATE: 'Datum *',
    POLICY_NUMBER: 'Broj polise',
    OFFER_NUMBER: 'Broj ponude',
    INSURED_PERSON_UCN: 'JMBG osiguranika',
    CONTRACTOR_UCN: 'JMBG ugovarača',
    POLICY: 'Polisa',
    POLICY_HOLDER_ID_OR_VAT: 'PIB ili matični broj ugovarača',
    INSURED_PERSON: 'Osiguranik',
    INSURANCE: 'Osiguranje',
    CONTRACTOR: 'Ugovarač',
    POLICY_SELECT_LABEL: 'Polisa',
    POLICY_NO_END_DATE: 'nema kraj',
    RISK: 'Rizik',
    RISK_LABEL: 'Šta prijavljujete?',
    DATE_OF_OCCURANCE: 'Datum nastanka osiguranog slučaja',
    TIME_PERIOD: 'Period važenja',
    POLICY_INSTRUCTIONS_1: 'Molimo Vas da unesete broj polise ili broj ponude ili matični broj osiguranika',
    POLICY_INSTRUCTIONS_2: 'Odaberite željenu polisu',
    TIME_OF_OCCURANCE: 'Vreme nastanka',
    COUNTRY: 'Država',
    STREET: 'Ulica i broj',
    MUNICIPALITY: 'Opština',
    CURRENT_RESIDENCE_ADDRESS: 'Da li je adresa trenutnog boravišta ista kao adresa prebivališta? *',
    MAILING_ADDRESS: 'Da li je adresa za slanje pošte ista kao adresa prebivališta? *',
    CITY: 'Mesto',
    CONFIRM_DELETE: 'Da li ste sigurni da želite da poništite prijavu za ovog korisnika?',
    SUBMITTER: 'Podnosilac',
    CLAIM_SUBMITTER: 'Podnosilac zahteva',
    CITIZENSHIP: 'Državljanstvo',
    ZIP_CODE: 'Poštanski broj',
    INSURED_BY_POLICY: 'Da li ste osiguranik po polisi? *',
    ARE_YOU_LOWER: 'Da li ste advokat/punomoćnik?',
    // INSURED: 'Osiguranik',
    INSURED_ACTIVE_DATE: 'Od *',
    INSURED_TYPE: 'Osiguranik je naš *',
    DATE_OF_BIRTH: 'Datum rođenja *',
    SELECT_PERSONAL_DOC_TYPE: 'Vrsta ličnog dokumenta',
    PERSONAL_DOC_NUMBER: 'Broj ličnog dokumenta',
    ISSUE_PLACE: 'Mesto izdavanja ličnog dokumenta',
    ISSUE_DATE: 'Datum izdavanja ličnog dokumenta *',
    PLACE_OF_BIRTH: 'Mesto rođenja',
    GENDER: 'Pol',
    FOREIGN_TAXPAYER: 'Da li ste poreski obveznik druge države?',
    TAXPAYER_COUNTRY: 'Država poreskog obveznika',
    EMAIL_CONTRACTOR: 'E-mail ugovarača (opciono)',
    ATTORNEY_WITH_USA_RESIDENCE: 'Da li imate punomoćnika sa boravištem/sedištem u SAD? *',
    IGA_FATCA:
        'Imajući u vidu sporazum IGA FATCA (Foreign Account Tax Compliance Act), u vezi sa kojim je Vlada Republike Srbije zvanično potvrdila nameru za potpisivanje istog sa Vladom SAD-a, kompanija GENERALI OSIGURANJE SRBIJA a.d.o. je u obavezi da Vas zamoli da odgovorite na dole navedena pitanja.',
    ARE_YOU_CITIZEN: 'Da li ste građanin/',
    RESIDENT: 'rezident*',
    OF_USA: ' Sjedinjenih Američkih Država? *',
    ARE_YOU_USA_TAXPAYER: 'Da li ste poreski obveznik u Sjedinjenim Američkim Državama? *',
    TIN_NUMBER: 'Unesite poreski broj TIN',
    USA_PERMANENT_ACCOUNT:
        'Da li imate trajni nalog za transfer sredstava na račun koji se drži u Sjedinjenim Državama? *',
    REMAINING_CHARACTERS: 'Preostalo karaktera:',
    PAYMENT_USER: 'Da li naknadu isplaćujemo korisniku ',
    PAYMENT_REASON:
        'Ukoliko odlučite da se isplata izvrši trećem licu, neophodno je da priložite izjavu o razlozima isplate trećem licu, overenu kod notara.',
    OUTLIVE_FULL_PAYMENT: 'Da li se isplata vrši u celosti?',
    OUTLIVE_TRANSFER:
        'Da li se vrši prenos sredstava na novu ponudu? Prenos može biti izvršen jedino u valuti polise koja je istekla.',
    PURCHASE_TRANSFER:
        'Da li se vrši prenos sredstava na novu ponudu? Prenos može biti izvršen jedino u valuti u kojoj je ugovorena polisa.',
    OUTLIVE_TRANSFER_FULL: 'u celosti',
    OUTLIVE_TRANSFER_PARTIAL: 'delimično',
    OUTLIVE_OFFER: 'Na ponudu broj: ',
    OUTLIVE_AMOUNT: 'U iznosu od: ',
    OUTLIVE_TRANSFER_TYPE: 'Način prenosa sredstava: ',
    OUTLIVE_TRANSFER_TYPE_AMOUNT_2:
        'Ukoliko su uneta dva broja ponude, razlika između ukupnog iznosa za isplatu i iznosa za prenos na prvu ponudu će biti uplaćena na drugu ponudu.',
    ATTORNEY_SIGNATURE: 'Punomoćnik je potpisao AML upitnik',
    USER_SIGNATURE: 'Korisnik je potpisao AML upitnik',
    AML_FOR_CLIENT: 'AML upitnik za klijenta',
    FORM_ID_OWNER: 'Obrazac za identifikaciju stvarnog vlasnika',
};

export enum personType {
    initialValue = 0,
    submitter = 1,
    user = 2,
    thirdPerson = 3,
}

export enum legalPersonType {
    initialValue = '0',
    individual = '1',
    legal = '2',
}

export enum riskType {
    initialValue = 0,
    accident = 1,
    deathByAccident = 2,
    death = 3,
}

export enum policyUser {
    submitter = 'podnosilac',
    submitterAndAdditionalPersons = 'podnosilac i dodatna lica',
    insuredPerson = 'osuguranik',
    thirdPerson = 'trece lice',
}

export enum paymentType {
    jmbg = '1',
    account = '2',
}

export enum submitterRole {
    contractor = 'Ugovarač osiguranja po izabranoj polisi',
    attorney = 'Ovlašćeni punomoćnik',
}

export enum transferTypeValues {
    partial = '1',
    full = '2',
}

export const paymentTypeOptions = [
    {
        id: paymentType.account,
        value: 'Tekući račun',
    },
    {
        id: paymentType.jmbg,
        value: 'JMBG (isplaćenu naknadu mozete podići u najbližoj Pošti uz ličnu kartu)',
    },
];

export enum bankType {
    domestic = 'domaca banka',
    iban = 'devizni racun',
    internacional = 'inostrana',
}

export const policiesProperties = {
    policyNumber: 'brojPolise',
    insuredPerson: 'osiguranik',
    contractor: 'ugovarac',
    insurance: 'osiguranje',
    risks: 'rizici',
    validFrom: 'vaziOd',
    validTo: 'vaziDo',
    message: 'poruka',
    riskName: 'naziv',
};

export enum personalDocumentType {
    initialValue = 0,
    idCard = 1,
    passport = 2,
}

export const personalDocumentOptions = [
    {
        id: personalDocumentType.idCard,
        value: 'Lična karta',
    },
    {
        id: personalDocumentType.passport,
        value: 'Pasoš',
    },
];

export enum genderType {
    initialValue = 0,
    male = 1,
    female = 2,
}

export const genderOptions = [
    {
        id: genderType.male,
        value: 'Muški',
    },
    {
        id: genderType.female,
        value: 'Ženski',
    },
];

export enum riskTypeTranslation {
    'Nezgoda' = 1,
    'Smrt usled nezgode' = 2,
    'Prirodna smrt' = 3,
}

export const acceptedUploadFileTypesArray = ['pdf', 'jpg', 'jpeg', 'png', 'doc', 'docx', 'rtf', 'xls', 'xlsx', 'txt'];
export const questionMaxLength = 100;
export const question50MaxLength = 50;
export const question25MaxLength = 25;
export const policyNoMaxLength = 10;
export const offerNoMaxLength = 10;
export const nameMaxLength = 20;
export const surnameMaxLength = 30;
export const ucnMaxLength = 13;

export enum riskTypeLife {
    death = 1,
    deathByAccident = 2,
    deathByTrafficAccident = 3,
    seriousIllness = 4,
    injury = 5,
    surgicalInterventionDueToInjury = 6,
    hospitalDaysDueToInjury = 7,
    surgicalInterventionDueToIllness = 8,
    hospitalDaysDueToIllness = 9,
    outlive = 10,
    purchase = 11,
}
